import { render, staticRenderFns } from "./ProspectiveProject.vue?vue&type=template&id=46a7dc60"
import script from "./ProspectiveProject.vue?vue&type=script&lang=js"
export * from "./ProspectiveProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports